import { Action,action } from 'easy-peasy';
import { LocalType } from '../types/LocauxType';

export interface SmartBuildingModel {
  smartBuildingFavourites: LocalType[];
  setSmartBuildingFavourites: Action<SmartBuildingModel, LocalType>;
  removeSmartBuildingFavourites: Action<SmartBuildingModel, LocalType>;
}

const smartBuilding: SmartBuildingModel = {
  smartBuildingFavourites: [],
  setSmartBuildingFavourites: action((state, payload) => {
    const index = state.smartBuildingFavourites.findIndex(
      obj => obj.idPSIZNL === payload.idPSIZNL,
    );
    if (index === -1) {
      state.smartBuildingFavourites = state.smartBuildingFavourites.concat(
        payload,
      );
    }
  }),
  removeSmartBuildingFavourites: action((state, payload) => {
    state.smartBuildingFavourites = state.smartBuildingFavourites.filter(
      fav => fav.idPSIZNL !== payload.idPSIZNL,
    );
  }),

};

export default smartBuilding;
